import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../../helpers';
import { store } from '../../../../../store/store';
import { Provider } from 'react-redux';
import apiClient from '../../../../../Services/NetteApiClient';
import { CustomTimePickerTime } from '../../../../BaseModule/Components/TimePickerCustom/TimePickerCustom';
import DateSelection from './DateSelection';

loadDOMComponent({
	selector: 'react-date-selection',
	callback: ({ container, context }: any) => {
		const workplaceId = container.getAttribute('workplaceId');
		const workplaceMemberId = container.getAttribute('workplaceMemberId');
		const workplaceCaseTypeId = container.getAttribute('workplaceCaseTypeId');
		const onSubmit = container.getAttribute('onSubmit');
		const minDate = container.getAttribute('minDate');
		const maxDate = container.getAttribute('maxDate');
		const preselectedDateTime = container.getAttribute('preselectedDateTime');

		const handleSubmit = (data: CustomTimePickerTime) => {
			apiClient.post(onSubmit, {
				...data,
			});
		};

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<DateSelection
						workplaceId={workplaceId}
						workplaceMemberId={workplaceMemberId}
						workplaceCaseTypeId={workplaceCaseTypeId}
						onSubmit={handleSubmit}
						minDate={minDate}
						maxDate={maxDate}
						preselectedDateTime={preselectedDateTime ?? undefined}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
